import moment from "moment";
import LineBox from "../../../../../DefaultStyles/LineBox";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import Table, { TableBody, TableBodyItem } from "../../../../../Table/Table";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import LineBtn from "../../../../../Button/LineBtn";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../../../../../hooks/useApi";
import {
  ISearchChat,
  recentChatBtnClick,
} from "../../../ChatInfo/ChatSearch/ChatSearchResult";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../../ApiTS/ServiceDatasTS";
import { useSetRecoilState } from "recoil";
import { chatTabState } from "../../../ChatInfo/ChatTab";
import { getSubsNameBySubsId3 } from "../../../../../../AdminApi/3.0_utils";

interface MatchMakingPartyChatModalProps extends DefaultModalCommonProps {}

export default function MatchMakingPartyChatModal({
  closeEvent,
}: MatchMakingPartyChatModalProps) {
  const navigate = useNavigate();

  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  const { response } = useApi({
    method: "get",
    url: "chat?ownerid=1&page=0&size=20",
  });

  return (
    <>
      <DefaultModalLayout
        modalTitle="채팅 수신 이력"
        closeEvent={() => closeEvent()}
        confirmEvent={() => closeEvent()}
        confirmBtnText="확인"
        cancelBtn={<></>}
      >
        <LineBox style={{ padding: "20px 30px" }} boxHeight={"440px"}>
          <Table
            tableMinWidth={436}
            tableHeadData={[
              "수신 일시",
              "Subscription",
              "PID",
              "파티원",
              "채팅",
            ]}
          >
            <>
              {response?.data?.items?.map((d: ISearchChat) => {
                return (
                  <TableBody>
                    <TableBodyItem isKeepAll={true}>
                      {moment(d?.lastupdate ?? undefined).format(
                        "YYYY-MM-DD HH:mm"
                      )}
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {getSubsNameBySubsId3(d?.servsubsid) ?? ""}
                    </TableBodyItem>
                    <TableBodyItem clickable={true}>{d?.partyid}</TableBodyItem>
                    <TableBodyItem clickable={true}>
                      {d?.member?.uid}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="바로가기"
                        onClick={() => {
                          setTab(1);
                          setRecentBtnClick(true);

                          navigate({
                            pathname: `/party/chat`,
                            search: `${d?.partyid}@${1}@${d?.member?.uid}`,
                          });
                        }}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
            </>
          </Table>
        </LineBox>
      </DefaultModalLayout>
    </>
  );
}
